export default "__VITE_ASSET__DU2h0DP$__"